import { FC } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, AlertTitle, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAppSelector } from '@hooks/redux-custom';
import { AddressListItem } from './AddressListItem/AddressListItem';
import { SubTitle } from '@components';
import AddNewAddress from './AddNewAddress/AddNewAddress';
import Alert from '@mui/material/Alert';
import { CustomerAddress } from '@models';

export const CustomerAddressList: FC = () => {
  const addresses = useAppSelector((state) => state.customer.value.selectedCustomer?.addresses);
  const activeUser = useAppSelector((state) => state.activeUser.value);
  const userAccessStatus = activeUser?.user?.roles.find((role: any) => role.moduleName === 'customer');
  const hasWriteAccess = userAccessStatus.role > 1;
  const maxAddresses = addresses && addresses.length < 10;

  return (
    <>
      <SubTitle title="Customer Addresses" />
      <Box data-testid="customer-addresses">
        {addresses?.map((address: CustomerAddress) => {
          return <AddressListItem address={address} key={address.id} />;
        })}
        {hasWriteAccess && maxAddresses ? (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="new-address-content"
              id="new-address-header"
              data-testid="new-address-header"
            >
              <Typography>New address</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <AddNewAddress />
            </AccordionDetails>
          </Accordion>
        ) : !hasWriteAccess ? (
          ''
        ) : (
          <Alert severity="warning">
            <AlertTitle>Customer has reached maximum number of addresses</AlertTitle>
            Customers are limited to 10 addresses on their record. Please delete one of the existing records before adding a new address.
          </Alert>
        )}
      </Box>
    </>
  );
};
